
import { Link, useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { logout } from '../../Utils/authUtils';

function Sidebar() {
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();


    const openLogoutModal = (e) => {
        e.preventDefault();
        setIsLogoutModalOpen(true);
    };

    const closeLogoutModal = () => {
        setIsLogoutModalOpen(false);
    };


    const handleLogout = () => {
        setIsLoggingOut(true);
        setIsLogoutModalOpen(false);
        setIsLoggingOut(false);
        logout("You have been logged out successfully.");
    }

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '560px',
            borderRadius: '8px',
            padding: '20px',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
        },
    };

    const isActiveTab = (path) => {
        return location.pathname === path;
    };

    return (
        <div className="LeftSideDiv">
            <div className="logo">
                <img src={window.getPublicUrl('/images/admin-logo.svg')} alt="Admin Logo" />
            </div>

            <ul className="top-ul">
                <li className={isActiveTab('/admin/dashboard') ? 'active' : ''}>
                    <Link to="/admin/dashboard">
                        <span>
                            <img src={window.getPublicUrl('/images/dashboard.svg')} alt="Dashboard" />
                        </span>
                        Dashboard
                    </Link>
                </li>
                <li className={isActiveTab('/admin/userManagement') ? 'active' : ''}>
                    <Link to="/admin/userManagement">
                        <span>
                            <img src={window.getPublicUrl('/images/customer.svg')} alt="User Management" />
                        </span>
                        User Management
                    </Link>
                </li>
                <li className={isActiveTab('/admin/contentManagement') ? 'active' : ''}>
                    <Link to="/admin/contentManagement">
                        <span>
                            <img src={window.getPublicUrl('/images/content-manag.svg')} alt="Content Management" />
                        </span>
                        Content Management
                    </Link>
                </li>
                <li className={isActiveTab('/admin/matchManagement') ? 'active' : ''}>
                    <Link to="/admin/matchManagement">
                        <span>
                            <img src={window.getPublicUrl('/images/match-mang.svg')} alt="Match Management" />
                        </span>
                        Match Management
                    </Link>
                </li>
                <li className={isActiveTab('/admin/analytics&Reporting') ? 'active' : ''}>
                    <Link to="/admin/analytics&Reporting">
                        <span>
                            <img src={window.getPublicUrl('/images/analysis.svg')} alt="Analytics & Reporting" />
                        </span>
                        Analytics & Reporting
                    </Link>
                </li>
                <li className={isActiveTab('/admin/planManagement') ? 'active' : ''}>
                    <Link to="/admin/planManagement">

                        <span>
                            <img src={window.getPublicUrl('/images/plan-haeder.svg')} alt="Plan Management" />
                        </span>
                        Plan Management
                    </Link>
                </li>
                <li className={isActiveTab('/admin/planHistory') ? 'active' : ''}>
                    <Link to="/admin/planHistory">

                        <span>
                            <img src={window.getPublicUrl('/images/plan-haeder.svg')} alt="Plan History" />
                        </span>
                        Plan History
                    </Link>
                </li>
                <li className={isActiveTab('/admin/campaignNotification') ? 'active' : ''}>
                    <Link to="/admin/campaignNotification">
                        <span>
                            <img src={window.getPublicUrl('/images/Frame 1984078767.svg')} alt="Campaign Notification" />
                        </span>
                        Campaign Notification
                    </Link>
                </li>
            </ul>

            <ul>
                <li className={`mar-top ${isActiveTab('/admin/settings') ? 'active' : ''}`}>
                    <Link to="/admin/settings">
                        <span>
                            <img src={window.getPublicUrl('/images/setting.svg')} alt="Settings" />
                        </span>
                        Settings
                    </Link>
                </li>
                <li>
                    <a href="#" onClick={openLogoutModal}>
                        <span>
                            <img src={window.getPublicUrl('/images/logout.svg')} alt="Logout" />
                        </span>
                        Logout
                    </a>
                </li>
            </ul>

            <Modal
                isOpen={isLogoutModalOpen}
                onRequestClose={closeLogoutModal}
                style={customStyles}
                contentLabel="Logout Confirmation"
            >
                <div className="">

                    {/* <div className="modal-header">
                        <h3>Confirm Logout</h3>
                        <img
                            src=""
                            className="close"
                            alt="Close"
                        />
                    </div>
                    <p>Are you sure you want to logout?</p> */}
                    <div className="modal-content">
                        <div className="modal-header">
                            {/* <h3>Confirm Logout</h3> */}
                            <div className="block-img">
                                <img src="/images/logout-icon.svg" className="img-fluid" alt="Block icon" />
                            </div>
                            <button type="button" onClick={closeLogoutModal} className="close" data-dismiss="modal" aria-label="Close">
                                <img src="/images/close-icon.svg" alt="Close" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-12">
                                    <h3>Logout </h3>
                                    <p>Are you sure you want to log out of your account?</p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-cancel" data-dismiss="modal" onClick={closeLogoutModal}>Cancel</button>
                            <button type="button" className="btn btn-save" onClick={handleLogout} disabled={isLoggingOut}>    {isLoggingOut ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Logging out...
                                </>
                            ) : (
                                "Logout"
                            )}</button>
                        </div>
                    </div>
                    {/* <button
                            onClick={closeLogoutModal}
                            className="reset me-2 mt-3"
                        >
                            Cancel
                        </button>
                        <button onClick={handleLogout} className="save" disabled={isLoggingOut}>
                            {isLoggingOut ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Logging out...
                                </>
                            ) : (
                                "Logout"
                            )}
                        </button> */}

                </div>
            </Modal>
        </div>
    );
}

export default Sidebar;